<template>
    <div class="card-body">

        <div class="d-flex justify-content-between">

            <div>
                <strong>{{table.name}}</strong>

                <router-link :to="{ name: 'edit-table', params: {id: table.id}}" class="ms-2">
                    <i class="fas fa-edit"></i>
                </router-link>

                <a href="javascript:void(0)" @click="onDeleteTableClick(table.id)" class="ms-2">
                    <i class="fas fa-trash-alt"></i>
                </a>

            </div>

        </div>

        <div class="row">
            <div class="col-md-6 col-sm-12">
                <fields-list :table="table"></fields-list>
            </div>

            <div class="col-md-6 col-sm-12">
                <view-list :table="table"></view-list>
            </div>

        </div>

        <confirm-modal key="tableModal"
                       v-if="showConfirmTableModal"
                       @noEvent="showConfirmTableModal = false"
                       :yesEvent="deleteTable"
                       text="Are you sure you want to delete this table?">
        </confirm-modal>
    </div>
</template>

<script>

    import ConfirmModal from "../../components/ConfirmModal.vue"
    import FieldModal from "./FieldModal.vue";
    import ModelService from "../../services/ModelService";
    import ArrayUtil from "../../utils/ArrayUtil";
    import FieldsList from "./FieldsList.vue";
    import ViewList from "./ViewList.vue";

    export default {
        name: 'TableDetails',
        components: {ViewList, FieldsList, FieldModal, ConfirmModal},
        props: ['table'],
        data() {
            return {
                model: webase.model,
                service: new ModelService(),
                arrayUtil: new ArrayUtil(),
                data: null,
                showConfirmTableModal: false,
                deleteTable: function () {
                }
            }
        },
        computed: {
            hasFields() {
                return this.table.fields.length > 0
            },
            openRoute() {
                return { name: 'view-renderer', params: {id: this.table.views[0].id} }
            }
        },
        methods: {

            onDeleteTableClick(tableId) {
                this.showConfirmTableModal = true

                this.deleteTable = () => {

                    this.service.remove(tableId).then(() => {
                        this.arrayUtil.remove(this.model.app.tables, tableId)
                        this.showConfirmTableModal = false
                    }).catch((error) => {
                        console.log('Error removing table.')
                        console.log(error)
                        this.showConfirmTableModal = false
                    })
                }
            }
        }
    }
</script>

